import axios from "../api/axios";

export const getTeleconsultation = async (token: string) => {
  const res = await axios.get("teleconsultation", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data;
};
